import { makeAutoObservable, runInAction } from 'mobx'

import { fetcher } from 'src/utils/fetcher'
import { UserStore } from 'src/store/UserStore'

import type { TPlan } from './types'

export class PlansStore {
  loading = false

  plans: TPlan[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get plansWithoutTrial() {
    return this.plans.filter(({ recurring_type }) => recurring_type !== `trial`)
  }

  async fetchPlans() {
    this.loading = true

    const { data } = await fetcher.get<TPlan[]>(`/plans`, {
      headers: {
        AUTHORIZATION: UserStore.token,
        GOOGLE_CID: UserStore.cid,
      },
    })

    runInAction(() => {
      this.loading = false
      this.plans = data
    })

    return data
  }

  async cancel() {
    await fetcher.post(`/subscriptions/cancel`, null, {
      headers: {
        AUTHORIZATION: UserStore.token,
        GOOGLE_CID: UserStore.cid,
      },
    })

    await UserStore.fetchUser()
    await this.fetchPlans()
  }

  async enableTrial() {
    await fetcher.post(`/users/trials`, null, {
      headers: {
        AUTHORIZATION: UserStore.token,
        GOOGLE_CID: UserStore.cid,
      },
    })

    await UserStore.fetchUser()
    await this.fetchPlans()
  }
}
